<template>
  <section>
    <div class="box p-4 mt-4">
      <div class="w-full items-center justify-between flex">
        <div class="flex gap-2 items-center text-xl font-bold">
          <i class="pi pi-pencil"></i>
          <p>Editar contrato # {{ contratosStore._header.NumCto }}</p>
        </div>
        <div class="flex gap-2">
          <Button icon="pi pi-copy" class="h-10"  @click="$router.push({ name: 'pharmasan.ventas.contrato-precio.crear', query: { copiar: $route.params.id } })" v-tooltip.left="'Crear copia con base a este contrato'" aria-label="Submit" />
          <Button @click="crearContrato()" severity="success" label="Guardar" icon="pi pi-save" />
        </div>
      </div>
      <div class="w-full mt-4">
        <div class="grid sm:grid-cols-1 md:grid-cols-6 gap-2">
          <div class="block gap-2">
            <label class="text-xs text-gray-600" for="valor_unitario">Contrato #</label>
            <InputText v-model="contratosStore.header.NumCto" class="w-full" />
            <span v-if="contratosStore.creando && !contratosStore._header.NumCto" class="text-xs text-red-400 italic">Este campo es requerido</span>
          </div>
          <div class="block gap-2">
            <label class="text-xs text-gray-600" for="cliente">Cliente</label>
            <Dropdown
              v-model="contratosStore.header.cliente"
              :options="contratosStore._listado_clientes"
              placeholder="Seleccione"
              optionLabel="CardName"
              optionValue="Id"
              class="w-full text-sm"
              filter
              showClear
              panelClass="text-sm"
            />
            <span v-if="contratosStore.creando && !contratosStore._header.cliente" class="text-xs text-red-400 italic">Este campo es requerido</span>
          </div>
          <div class="block gap-2">
              <label class="text-xs text-gray-600" for="valor_unitario">Fecha inicio</label>
              <input v-model="contratosStore.header.fecha_inicio" :max="contratosStore.header.fecha_fin" :style="{ padding: '0.45rem' }" class="w-full border rounded-md border-gray-400" type="date">
              <span v-if="contratosStore.creando && !contratosStore._header.fecha_inicio" class="text-xs text-red-400 italic">Este campo es requerido</span>
            </div>
            <div class="block gap-2">
              <label class="text-xs text-gray-600" for="valor_unitario">Fecha fin</label>
              <input v-model="contratosStore.header.fecha_fin" :min="contratosStore.header.fecha_inicio" :style="{ padding: '0.45rem' }" class="w-full border rounded-md border-gray-400" type="date">
              <span v-if="contratosStore.creando && !contratosStore._header.fecha_fin" class="text-xs text-red-400 italic">Este campo es requerido</span>
            </div>
          <div class="block gap-2">
            <label class="text-xs text-gray-600" for="valor_unitario">Valor del contrato</label>
            <InputNumber v-model="contratosStore.header.ValorTotal" class="w-full" inputId="currency-us" mode="currency" currency="COP" locale="es-CO" />
            <!-- <span v-if="contratosStore.creando && !contratosStore._header.ValorTotal" class="text-xs text-red-400 italic">Este campo es requerido</span> -->
          </div>
          <div>
            <label class="text-xs text-gray-600" for="valor_unitario">Eps</label>
            <AutoComplete @item-select="agregarEps" v-model="epsSeleccionada" :suggestions="contratosStore._eps_encontradas" optionLabel="CardName" class="w-full text-xs" inputClass="text-xs w-full" :inputStyle="{'padding': '0.65rem'}" panelClass="text-xs" @complete="buscarEps($event)" />
            <div class="flex flex-wrap gap-1 mt-1 max-h-32 overflow-y-auto" v-if="contratosStore._header.Eps.length">
              <div style="height: min-content;" class="text-xs flex flex-wrap" v-for="eps in contratosStore._header.Eps" :key="eps">
                <div style="height: min-content;" class="p-1 rounded-md bg-blue-300 h-min text-blue-600 flex gap-1 items-center">
                  <button @click="eliminarEps(eps)"><i class="pi pi-times text-xs"></i></button>
                  <p>{{ eps.CardCode + ' - ' + eps.CardName }}</p>
                </div>
              </div>
            </div>
            <span v-if="contratosStore.creando && !contratosStore._header.Eps.length" class="text-xs text-red-400 italic">Este campo es requerido</span>
          </div>
        </div>
        <div class="w-full mt-2">
          <label class="text-xs text-gray-600" for="descripcion">Descripción del contrato</label>
          <Textarea id="descripcion" v-model="contratosStore.header.Descript" class="w-full" rows="2" cols="30" />
        </div>
      </div>
      <div class="w-full">
        <TabView>
          <TabPanel header="Modalidad/Motivos">
            <Motivos :motivosPadre="listadoMotivosAutorizacion" />
          </TabPanel>
          <TabPanel header="Zonificación">
              <Zonificacion />
          </TabPanel>
          <TabPanel v-if="contratosStore._modalidad_contrato_seleccionada === '01'" header="Pacientes">
            <Pacientes />
          </TabPanel>
          <TabPanel header="Articulos/Precios">
            <ListaPrecio />
          </TabPanel>
          <TabPanel header="Soportes">
            <Soportes/>
          </TabPanel>
        </TabView>
      </div>
      <Dialog :closable="false" v-model:visible="modalBorrador" modal header="Creación contrato" :style="{ width: '40vw' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">
        <div class="w-full mb-4">
          <label for="documento" class="text text-gray-600 italic">Elija como desea guardar el contrato</label>
        </div>
        <template #footer>
          <Button @click="guardarContrato(1)" label="Publicar" severity="success" icon="pi pi-save" />
          <Button @click="guardarContrato(2)" label="Guardar Borrador" severity="secondary" icon="pi pi-save" />
          <Button @click="modalBorrador = false" label="Cancelar" severity="danger" icon="pi pi-times" />
        </template>
      </Dialog>
    </div>
  </section>
</template>
<script>
  import { onMounted, ref, defineAsyncComponent } from 'vue'
  import { useRoute, useRouter } from 'vue-router'
  import { useContratosStore } from '../../stores/contratos.store'
  import { useToast } from 'primevue/usetoast'
  import Swal from 'sweetalert2'
  export default {
    name: 'configuracionContratosCrear',
    components: {
      Zonificacion: defineAsyncComponent(() => import('./components/zonificacion.vue')),
      Pacientes: defineAsyncComponent(() => import('./components/pacientes.vue')),
      ListaPrecio: defineAsyncComponent(() => import('./components/articulos.vue')),
      Soportes: defineAsyncComponent(() => import('./components/soportes.vue')),
      Motivos: defineAsyncComponent(() => import('./components/motivos.vue'))
    },
    setup () {
      const route = useRoute()
      const router = useRouter()
      const toast = useToast()
      const contratosStore = useContratosStore()
      const modalBorrador = ref(false)
      const listadoMotivosAutorizacion = ref([])
      const listadoRegimenes = ref([])
      const regimenSeleccionado = ref()
      const regimenesSeleccionados = ref([])
      const epsSeleccionada = ref()
      const ingresarRegimen = () => {
        listadoRegimenes.value = listadoRegimenes.value.filter(a => a.code !== regimenSeleccionado.value.code)
        regimenesSeleccionados.value.push(regimenSeleccionado.value)
        regimenSeleccionado.value = ''
      }
      const eliminarRegimen = (codigo) => {
        listadoRegimenes.value.push(regimenesSeleccionados.value.find(a => a.code === codigo))
        regimenesSeleccionados.value = regimenesSeleccionados.value.filter(a => a.code !== codigo)
      }
      const motivosAutorizacionFiltrados = () => {
        listadoMotivosAutorizacion.value = []
        for (const i of contratosStore._listado_motivos_autorizacion) {
          if (i.CodModContrato === contratosStore._modalidad_contrato_seleccionada && !contratosStore.header.MotivosAutorizacion.some(a => a.Id === i.Id)) {
            listadoMotivosAutorizacion.value.push(i)
          }
        }
      }
      const cambioModalidadContrato = () => {
        contratosStore.header.MotivosAutorizacion = []
        listadoMotivosAutorizacion.value = contratosStore._listado_motivos_autorizacion.filter(a => a.CodModContrato === contratosStore._modalidad_contrato_seleccionada)
      }
      const crearContrato = () => {
        modalBorrador.value = true
      }
      const guardarContrato = (tipo) => {
        if (!contratosStore._header.cliente) return toast.add({ severity: 'warn', summary: 'Advertencia', detail: 'Debe ingresar un cliente para continuar', life: 3000 })
        if (!contratosStore._header.MotivosAutorizacion.length) return toast.add({ severity: 'warn', summary: 'Advertencia', detail: 'Debe ingresar un motivo para continuar', life: 3000 })
        if (!contratosStore._header.Eps.length) return toast.add({ severity: 'warn', summary: 'Advertencia', detail: 'Debe ingresar una eps para continuar', life: 3000 })
        if (!contratosStore._header.fecha_inicio) return toast.add({ severity: 'warn', summary: 'Advertencia', detail: 'Debe ingresar una fecha inicio para continuar', life: 3000 })
        if (!contratosStore._header.fecha_fin) return toast.add({ severity: 'warn', summary: 'Advertencia', detail: 'Debe ingresar una fecha fin para continuar', life: 3000 })
        contratosStore.actualizar(tipo, route.params.id).then((data) => {
          if (data) {
            if (typeof data === 'string') {
              Swal.fire({
                icon: 'warning',
                title: 'Validacion Contrato',
                text: data
              })
            } else {
              Swal.fire({
                icon: 'success',
                title: 'Actualizar Contrato',
                text: 'Se actualizó el contrato exitosamente'
              }).then(() => {
                router.push({ name: 'pharmasan.ventas.contrato-precio.listado' })
              })
            }
          } else {
            Swal.fire({
              icon: 'warning',
              title: 'Actualizar Contrato',
              text: 'Ha ocurrido un error, valida la infomación ingresada'
            })
          }
        })
        modalBorrador.value = false
      }
      const buscarEps = (event) => {
        contratosStore.buscarEps({ CardName: event.query })
      }
      const agregarEps = () => {
        contratosStore.header.Eps.push(epsSeleccionada.value)
        epsSeleccionada.value = ''
      }
      const eliminarEps = (data) => {
        contratosStore.header.Eps = contratosStore._header.Eps.filter(a => a.CardCode !== data.CardCode)
      }
      onMounted(() => {
        contratosStore.findContrato(route.params.id).then((data) => {
          contratosStore.obtenerMotivosAutorizacion().then((info) => {
            if (data.CtoMotAutoriza.length) {
              contratosStore.modalidad_contrato_seleccionada = info.find(a => a.Id === data.CtoMotAutoriza[0].MotAutorizaId)?.CodModContrato
            }
            listadoMotivosAutorizacion.value = contratosStore._listado_motivos_autorizacion.filter(a => a.CodModContrato === contratosStore._modalidad_contrato_seleccionada)
            motivosAutorizacionFiltrados()
          })
        })
        contratosStore.obtenerClientes()
        contratosStore.listarModalidadesContrato()
      })
      return {
        listadoMotivosAutorizacion,
        listadoRegimenes,
        ingresarRegimen,
        regimenSeleccionado,
        eliminarRegimen,
        regimenesSeleccionados,
        contratosStore,
        motivosAutorizacionFiltrados,
        cambioModalidadContrato,
        crearContrato,
        modalBorrador,
        guardarContrato,
        buscarEps,
        agregarEps,
        eliminarEps,
        epsSeleccionada
      }
    }
  }
</script>
<style scoped>
  .border-input {
    padding: 0.45rem 0.75rem;
    border: 1px solid #ced4da;
  }
  ::-webkit-scrollbar {
    width: 0.4rem;
    margin: 1rem;
    padding: 1rem;
  }
  ::-webkit-scrollbar-thumb {
    background: rgb(189, 189, 189);
    border-radius: 9999px;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
  ::-webkit-input-placeholder { /* Edge */
    color: gray;
  }
</style>
